export default {
  methods: {
    setDisplayTime(time) {
    	let today = new Date();
      let text = today.getFullYear();
      let monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
		'October',
        'November',
        'December'
      ];

      let date = new Date();
      let month = date.getMonth();

      switch (time) {
        case "today":
          let day = date.getDate();

          if (day === 1) {
            text = `${monthNames[month]}, 1st ${text}`;
          } else if (day === 2) {
            text = `${monthNames[month]}, 2nd ${text}`;
          } else if (day === 3) {
            text = `${monthNames[month]}, 3rd ${text}`;
          } else {
            text = `${monthNames[month]}, ${day}th ${text}`;
          }
          break;
        case "month":
          text = `${monthNames[month]} ${text}`;
          break;
      }

      return text;
    },
    setDisplayTitle(time) {
    	let today = new Date();
	    let text = today.getFullYear();
	    let textData = [];

	    let monthNames = [
		    'January',
		    'February',
		    'March',
		    'April',
		    'May',
		    'June',
		    'July',
		    'August',
		    'September',
		    'October',
		    'November',
		    'December'
	    ];

	    let date = new Date();
	    let month = date.getMonth();

	    switch (time) {
		    case "today":
			    let yesterday = this.getDayString(1);
			    let beforeYesterday = this.getDayString(2);
			    textData.push(yesterday, beforeYesterday);
			    break;
		    case "month":
		    	let prevMonth = '', beforePrevMonth = '';
		    	if (month - 1 < 0) {
						prevMonth = 'December';
				    beforePrevMonth = 'November';
			    } else {
				    prevMonth = monthNames[month - 1];
				    beforePrevMonth = monthNames[month - 2];
			    }
			    textData.push(prevMonth, beforePrevMonth);
			    break;
		    case "year":
			    let lastYear = today.getFullYear() - 1;
			    let beforeLastYear = today.getFullYear() - 2;
			    textData.push(lastYear, beforeLastYear);
			    break;
	    }

	    return textData;
    },
	  getDayString(days) {
    	let today = new Date();
    	let text = today.getFullYear();
		  let month = today.getMonth();
		  let shortMonthNames = [
			  'Jan',
			  'Feb',
			  'Mar',
			  'Apr',
			  'May',
			  'June',
			  'July',
			  'Aug',
			  'Sept',
			  'Nov',
			  'Dec'
		  ];

		  today.setDate(today.getDate() - days);
		  let day = today.getDate();
		  let _month = today.getMonth();
		  if (day === 1) {
			  text = `${shortMonthNames[_month]} 1st ${text}`;
		  } else if (day === 2) {
			  text = `${shortMonthNames[_month]} 2nd ${text}`;
		  } else if (day === 3) {
			  text = `${shortMonthNames[_month]} 3rd ${text}`;
		  } else {
			  text = `${shortMonthNames[_month]} ${day}th ${text}`;
		  }

			return text;
	  }
  }
};
